module.exports = "/images/pr.svg?73ae987c9f573fcc8e5171530faa0d63";